/*
 * @FilePath: \kitchen-online-web\src\hooks\homePagehooks\useList.js
 * @Author: Xiaohua Zhu
 * @Date: 2021-12-30 11:19:22
 * @LastEditors: Kun Yang
 * @LastEditTime: 2022-06-10 09:30:15
 * @Description: Description
 */
import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getWallList, getFloorList } from '@/apis/homePage.js';

const useWallList = () => {
  const { t } = useTranslation();

  // const id = dependencies;
  const [wallList, setWallList] = useState([]);
  const [error, setError] = useState(null);
  useMemo(() => {
    getWallList().then((res) => {
      if (res.data && res.data.data) {
        setWallList(res.data.data);
      } else {
        Promise.reject(new Error(t('dataError')));
      }
    }).catch((err) => {
      setError(err);
    });
  }, []);

  return { wallList, error };
};

const useFloorList = () => {
  const { t } = useTranslation();

  // const id = dependencies;
  const [floorList, setFloorList] = useState([]);
  const [error, setError] = useState(null);
  useMemo(() => {
    getFloorList().then((res) => {
      if (res.data && res.data.data) {
        setFloorList(res.data.data);
      } else {
        Promise.reject(new Error(t('dataError')));
      }
    }).catch((err) => {
      setError(err);
    });
  }, []);

  return { floorList, error };
};

export {
  useWallList,
  useFloorList,
};
